import React, { useEffect, useState } from 'react';
import { Star, Quote } from 'lucide-react';
import Ornament from './Ornament';
import { useI18n } from '../context/I18nContext';
import { publicApi } from '../api';
import { staticImg } from '../utils/media';

export default function Testimonials() {
  const { tr, meta, lang } = useI18n();
  const settings = meta?.settings || {};
  const [items, setItems] = useState([]);

  useEffect(() => {
    let isMounted = true;
    if (settings.show_testimonials === '1') {
      publicApi.testimonials(lang).then((data) => {
        if (isMounted && Array.isArray(data) && data.length > 0) {
          setItems(data);
        }
      }).catch(() => {});
    }
    return () => { isMounted = false; };
  }, [settings.show_testimonials, lang]);

  // Default toggle is OFF unless enabled in Admin Settings
  if (settings.show_testimonials !== '1') return null;

  const defaultTestimonials = [
    {
      name: 'Emre Öztürk',
      role: 'ValorMT2 Kurucusu',
      text: tr('test.1_text', 'Aegis ekibinin PvP files’ı sunucumuzu 3 haftada zirveye taşıdı. İnanılmaz optimize, sıfır crash.'),
      avatar: 'https://images.unsplash.com/photo-1618077360395-f3068be8e001?w=200&auto=format&fit=facearea&facepad=3',
    },
    {
      name: 'Selin Akın',
      role: 'Community Manager · CrimsonMT2',
      text: tr('test.2_text', 'Discord destek ekibi 24 saat aktif. Custom sistem taleplerimize haftalar değil günler içinde cevap veriyorlar.'),
      avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=200&auto=format&fit=facearea&facepad=3',
    },
    {
      name: 'Marek K.',
      role: 'Owner · IronBlade EU',
      text: tr('test.3_text', 'Cosmic VPS + DDoS koruma paketiyle ilk gecemizde 2 saldırı göğüslendi — kimse fark etmedi bile.'),
      avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&auto=format&fit=facearea&facepad=3',
    },
  ];

  const list = items.length > 0 ? items : defaultTestimonials;

  return (
    <section className="relative py-20 lg:py-28">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <Ornament className="mb-6" />
          <div className="text-xs font-bold tracking-[0.32em] text-[#e4b44e]/85 mb-3">{tr('test.eyebrow', 'MÜŞTERİ YORUMLARI')}</div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-black text-white leading-[1.05]">
            <span dangerouslySetInnerHTML={{ __html: tr('test.title', 'Sunucu Sahipleri <span class="gold-text">Ne Diyor?</span>') }} />
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {list.map((t, i) => (
            <div key={t.name || i} className="relative rounded-2xl border border-white/8 bg-gradient-to-b from-[#111015] to-[#0a090c] p-8 card-hover">
              <Quote className="absolute top-6 right-6 w-10 h-10 text-[#e4b44e]/15" />
              <div className="flex items-center gap-0.5 mb-5">
                {Array.from({ length: t.rating || 5 }).map((_, idx) => (
                  <Star key={idx} className="w-4 h-4 fill-[#e4b44e] text-[#e4b44e]" />
                ))}
              </div>
              <p className="text-white/80 leading-relaxed mb-8 relative z-10">“{t.text || t.content || t.comment}”</p>
              <div className="flex items-center gap-3 pt-5 border-t border-white/8">
                {t.avatar || t.image ? (
                  <img src={staticImg(t.avatar || t.image)} alt={t.name} className="w-11 h-11 rounded-full object-cover border border-[#e4b44e]/40" />
                ) : (
                  <div className="w-11 h-11 rounded-full bg-[#e4b44e]/20 border border-[#e4b44e]/40 flex items-center justify-center font-bold text-[#e4b44e]">
                    {(t.name || 'M')[0]}
                  </div>
                )}
                <div>
                  <div className="text-sm font-bold text-white">{t.name}</div>
                  <div className="text-xs text-white/50">{t.role || t.title}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
